import { gql } from '@grandvisionhq/graphql';

const contactLensBundleBeneluxTypeDetails = gql`
  fragment ContactLensBundleBeneluxTypeDetailsFragment on ContactLensBundleBeneluxTypeDetails {
    prescription {
      rightLens {
        baseCurve
        diameter
        power
        axis
        cylinder
      }
      leftLens {
        baseCurve
        diameter
        power
        axis
        cylinder
      }
    }
  }
`;

export { contactLensBundleBeneluxTypeDetails };
//# sourceMappingURL=contact-lens-bundle-benelux.js.map
